import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled, { createGlobalStyle, css } from 'styled-components'
import { format, isValid, parse } from 'date-fns'
import DatePickerComponent from 'react-datepicker'

import MaskInput from '../MaskInput/MaskInput'
import 'react-datepicker/dist/react-datepicker.css'

const StyledDatePicker = createGlobalStyle`
  .react-datepicker__month .react-datepicker__month-text {
    padding: .5rem 1rem;
  }

  .react-datepicker-popper {

    &[data-placement^="bottom"] {
      margin-top: 0;
    }
  }

  .react-datepicker{
    border: none;
    box-shadow: var(--box-shadow-form);

    &__triangle {
      display: none;
    }

    &__navigation {
      outline: none;
    }

    &__header {
      border: none;
      background: #ffffff;

    }

    &__month {

      &--selected, &--selected:hover {
        background-color: var(--color-primary-hover) !important;
      }

      &-wrapper {
        display: flex;
        width: 100%;
      }
    }
  }

  .react-datepicker{

    &__month {

      &-wrapper {
        display: flex;
        width: 100%;
      }
    }
  }

  .react-datepicker-wrapper  {
    width: 100%;
  }
`

const StyledDatePickerComponent = styled(DatePickerComponent)``

const ControlBase = styled.label`
  position: relative;
  display: block;
  width: 100%;
  height: 3.5rem;
  padding-top: 0.5rem;
  font-size: 1rem;
  ${({ variant }) =>
    variant === 'small' &&
    css`
      font-size: 0.8rem;
      color: var(--color-fg);
    `}

  & > * {
    .react-datepicker {
      font-family: inherit;

      &__month {
        &-container {
          border: none;
        }
      }

      &__day {
        &--outside-month {
          opacity: 0.5;
        }

        &--selected {
          background: var(--color-primary);
          border-radius: 50%;
        }

        &:hover {
          border-radius: 50%;
        }
      }
    }
  }
`

const ComponentBase = styled.div`
  margin-bottom: 0.625rem;
`

const ErrorMessage = styled.output`
  display: block;
  color: var(--color-error);
  padding: 0 1rem;
  font-size: 0.75em;
  margin-top: 0.25rem;
  overflow: hidden;
  height: 1.125rem;
  transition-property: height, opacity;
  transition-duration: var(--animation-duration);
  transition-timing-function: var(--animation-easing);

  :empty {
    height: 0;
    opacity: 0;
  }

  ${ControlBase}:focus-within ~ & {
    height: 0;
    opacity: 0;
  }
`

class DatePicker extends React.Component {
  state = {
    selectedDate: null,
  }

  componentDidMount() {
    const { initialValue } = this.props

    if (initialValue) {
      this.setDate(initialValue)
    }
  }

  componentDidUpdate(prevProps) {
    const { initialValue } = this.props

    if (!initialValue && initialValue !== prevProps.initialValue) {
      this.resetSelectedDate()
    }
  }

  resetSelectedDate = () => {
    this.setState({
      selectedDate: null,
    })
  }

  setDate = date => {
    const formattedDate = new Date(date)
    const { onChange, name, dateValueFormat = 'YYYY-MM-DD' } = this.props

    this.setState({
      selectedDate: formattedDate,
    })

    if (onChange) {
      onChange({
        target: {
          name,
          value: format(formattedDate, dateValueFormat),
        },
      })
    }
  }

  render() {
    const {
      placeholder,
      error,
      touched,
      max,
      dateValueFormat = 'YYYY-MM-DD',
      dateMask = '99/99/9999',
      maskInput = true,
      variant,
      withIcon,
      ...props
    } = this.props

    const { selectedDate } = this.state

    let formattedMax = null

    if (isValid(parse(max))) {
      formattedMax = format(max, dateValueFormat)
    }

    return (
      <ComponentBase>
        <StyledDatePicker />
        <ControlBase>
          <StyledDatePickerComponent
            {...props}
            customInput={
              <MaskInput
                dateMask={dateMask}
                maskInput={maskInput}
                variant={variant}
                withIcon={withIcon}
              />
            }
            placeholderText={placeholder}
            selected={selectedDate}
            maxDate={new Date(formattedMax)}
            onChange={this.setDate}
            hasError={touched && error}
          />
        </ControlBase>
        <ErrorMessage>{touched && error}</ErrorMessage>
      </ComponentBase>
    )
  }
}

DatePicker.defaultProps = {
  placeholder: '',
  initialValue: '',
  error: null,
  touched: false,
}

DatePicker.propTypes = {
  placeholder: PropTypes.string,
  initialValue: PropTypes.string,
  error: PropTypes.string,
  touched: PropTypes.bool,
}

export default DatePicker
